import { Component, OnInit } from '@angular/core';
import { VehicleService } from 'src/app/vehicle/services/vehicle.service';
import { catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-vehicle-fleet-status-graph',
    templateUrl: './vehicle-fleet-status-graph.component.html',
    styleUrls: ['./vehicle-fleet-status-graph.component.scss'],
    standalone: false
})
export class VehicleFleetStatusGraphComponent implements OnInit {
  dataPie: any[] = [];
  loaded: boolean = false;

  view: any[] = [];
  gradient: boolean = false;
  showLegend: boolean = true;
  showLabels: boolean = true;
  doughnut: boolean = true;

  colorScheme = {
    domain: ['#5AA454', '#94a3b8']
  };

  constructor(private vehicleService: VehicleService) { }

  ngOnInit(): void {
    this.vehicleService.getAllVehicles()
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((vehicles) => {
        const active = vehicles.filter((v) => v.active).length;
        const inactive = vehicles.length - active;

        this.dataPie = [
          { name: 'Active', value: active },
          { name: 'Inactive', value: inactive },
        ];
        this.loaded = true;
      });
  }

}
